"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
exports.borderRadiusRegex = /\s*(\d?.?\d+)%\s(\d?.?\d+)%\s(\d?.?\d+)%\s(\d?.?\d+)%\s\/\s(\d?.?\d+)%\s(\d?.?\d+)%\s(\d?.?\d+)%\s(\d?.?\d+)%/;
exports.boxShadowRegex = /\s*(\d?.?\d+\D{0,3})\s(\d?.?\d+\D{0,3})\s(\d?.?\d+\D{0,3})\s(\d?.?\d+\D{0,3})\srgba\((\d?.?\d+)\s*,\s*(\d?.?\d+)\s*,\s*(\d?.?\d+),\s*(\d?.?\d+)\)/;
exports.cubicBezierRegex = /\s*(\d?.?\d+)\s*,\s*(\d?.?\d+)\s*,\s*(\d?.?\d+),\s*(\d?.?\d+)/;
// https://webbjocke.com/javascript-check-data-types/
exports.is = {
    hex: function (v) { return v.startsWith('#') && (v.length === 4 || v.length === 7); },
    hsl: function (v) { return v.startsWith('hsl('); },
    number: function (v) { return typeof v === 'number' && isFinite(v); },
    string: function (v) { return typeof v === 'string'; },
    unit: function (v) {
        return exports.is.string(v) &&
            (v.endsWith('px') ||
                v.endsWith('rem') ||
                v.endsWith('em') ||
                v.endsWith('%') ||
                v.endsWith('s') ||
                v.endsWith('ms'));
    },
    boxShadow: function (v) {
        var _a;
        var match = (_a = exports.boxShadowRegex.exec(v)) === null || _a === void 0 ? void 0 : _a.slice(1);
        return exports.is.string(v) && match && match.length === 8;
    },
    borderRadius: function (v) {
        var _a;
        var match = (_a = exports.borderRadiusRegex.exec(v)) === null || _a === void 0 ? void 0 : _a.slice(1);
        return exports.is.string(v) && match && match.length === 8;
    },
    cubicBezier: function (v) {
        var _a;
        var match = (_a = exports.cubicBezierRegex.exec(v)) === null || _a === void 0 ? void 0 : _a.slice(1);
        return exports.is.string(v) && match && match.length === 4;
    }
};
//# sourceMappingURL=is.js.map